import { useCallback, useEffect, useMemo, useRef } from 'react';

// Keep input state immediate; delay only the work triggered by typing.
export default function useDebouncedCallback(callback, delay = 400) {
    const latest = useRef(callback);
    const timer = useRef(null);
    latest.current = callback;

    const cancel = useCallback(() => {
        clearTimeout(timer.current);
        timer.current = null;
    }, []);

    useEffect(() => cancel, [cancel, delay]);

    return useMemo(() => {
        const debounced = (...args) => {
            cancel();
            timer.current = setTimeout(() => {
                timer.current = null;
                latest.current(...args);
            }, delay);
        };
        debounced.cancel = cancel;
        return debounced;
    }, [cancel, delay]);
}
